/* 请求路径配置
//  */
// let admin = 'http://192.168.0.105:8089/bookmall/sign/'
// let admin = 'http://localhost:8080/YSBookMall/sign/'
let admin = window.g.ysAdmin;
// let admin = 'http://115.28.9.142:8180/YSBookMall/sign/'
export const allUrl = {
  // 图片路径前缀
  // imgAdmin: 'http://ci.uestcdp.com/',
  imgAdmin: window.g.imgAdmin,
  // 获取图片验证码
  getPictureVeritfCode: admin + "userbase/getPictureVeritfCode",
  // 登录
  login: admin + "user/login",
  // 注册
  register: admin + "user/signInCustomer",
  // 获取短信验证码
  getSendVerifyCode: admin + "userbase/sendVerifyCode",
  // 上传用户头像
  updateCustomerHeadIcon: admin + "user/uploadCustomerHeadIcon",
  // 修改密码
  updatePassword: admin + "userbase/updatePassword",
  // 修改用户信息
  updateCustomer: admin + "user/updateCustomer",
  // 忘记密码
  resetPassword: admin + "userbase/resetPassword",
  // 搜索图书
  searchBooks: admin + "book/searchBooks",

  /**
   * 首页
   */
  // 获取热搜
  getHotWords: admin + "hotWords/getHotWords",
  // 获取顶部广告图片
  getTopAd: admin + "ad/getTopAd",
  // 获取图书分类
  getCatagory: admin + "catagory/getCatagory",
  // 获取轮播图片
  getBannerAd: admin + "ad/getBannerAd",
  // 获取排行榜
  getRanking: admin + "rank/getRanking",
  // 获取最新特价
  getDealsPromotion: admin + "promotion/getDealsPromotion",
  // 获取最新上架
  getNewShelfBooks: admin + "promotion/getNewShelfBooks",
  // 获取重磅推荐
  getBlockbuster: admin + "promotion/getBlockbuster",
  // 获取免费专区
  getFreeShelfBooks: admin + "promotion/getFreeShelfBooks",

  /**
   * 书籍详情
   */
  // 获取书籍详情
  getBookInfo: admin + "book/getBookInfo",
  // 用户添加收藏
  addFavorite: admin + "favorite/addFavorite",
  // 用户取消收藏
  deleteFavorite: admin + "favorite/deleteFavorite",
  // 获取书籍评论
  getComments: admin + "comment/getComments",
  // 添加评论
  addComment: admin + "comment/addComment",
  // 加入购物车
  addCart: admin + "cart/addCart",
  // 获取购物车商品数量
  getCartNum: admin + "cart/getCartNum",

  /**
   * 书籍详情
   */
  // 获取购物车书籍
  getCartBooks: admin + "cart/getCartBooks",
  // 删除购物车书籍
  deleteCart: admin + "cart/deleteCart",

  /**
   * 分类
   */
  // 获取图书分类数据
  getCategoryBooks: admin + "catagory/getCategoryBooks",
  // 获取活动专题
  getSubject: admin + "subject/getSubject",
  // 获取主题书籍列表
  getSubjectBooks: admin + "subject/getSubjectBooks",
  /**
   * 订单详情
   */
  // 获取用户收货地址
  getUserAddress: admin + "order/getUserAddress",
  // 新增收货地址
  addUserAddress: admin + "order/addUserAddress",
  // 删除收货地址
  deleteUserAddress: admin + "order/deleteUserAddress",
  // 设置默认地址
  updateDefaultUserAddress: admin + "order/updateDefaultUserAddress",
  // 新增订单
  addOrder: admin + "order/addOrder",
  // 获取订单列表
  getOrderList: admin + "order/getOrderList",
  // 删除订单
  deleteOrder: admin + "order/deleteOrder",
  // 获取支付
  pay: admin + "alipay/pay",
  /**
   * 订单详情
   */
  // 获取用户收藏
  getFavorite: admin + "favorite/getFavorite",
  // 我的书架
  getMyBookshelf: admin + "order/getMyBookshelf",
  // 阅读进度
  updateUserReadrate: admin + "user/updateUserReadrate",
  // 批量删除订单
  deleteCartList: admin + "cart/deleteCartList",
  // 确认收货
  userConfirmOrder: admin + "order/userConfirmOrder",
  // 获取快递信息
  getExpress: admin + "order/getExpress",
  // pdf试读
  getpdf: admin + "userbase/pdf"
};



// WEBPACK FOOTER //
// ./src/router/allUrl.js